const unique = list => list.filter((v,i) => list.indexOf(v) === i);

export default unique;